import '../App.js';
import React, { useState } from 'react';
import { useEffect } from 'react';

function Tags({ tagsLoaded }) {

    const [tags, setTags] = useState([]);

    useEffect(() => {
        const displayTags = async () => {            
            setTags(tagsLoaded);
        }
        
        displayTags();
    }, []);
    
    
    return (
        <div class='post-tags'>
            <span class='post-tag'>
                Tags:
            </span>
            {
                tags?.map((tag, index) => (
                    <div class={'post-tag' + ' ' + 'tag-' + tag} key={index}>
                        <span>#{tag}</span>
                        <span>&nbsp;</span>  
                    </div>
                ))
            }
        </div>
    )
};

export default Tags;